import {BookingSortColumn, type BookingSort, type PanelBooking} from "../types.ts";

export const DEFAULT_SORT: BookingSort = {column: BookingSortColumn.Date, ascending: true};

function sortValue(booking: PanelBooking, column: BookingSortColumn): number {
    switch (column) {
        case BookingSortColumn.Date: {
            if (!booking.date) return Number.MAX_SAFE_INTEGER;
            const timestamp = new Date(booking.date).getTime();
            return Number.isNaN(timestamp) ? Number.MAX_SAFE_INTEGER : timestamp;
        }
        case BookingSortColumn.Debit:
            return booking.debit.signed_amount;
        case BookingSortColumn.Credit:
            return booking.credit.signed_amount;
        default: {
            const _exhaustive: never = column;
            return _exhaustive;
        }
    }
}

export function sortBookings(bookings: PanelBooking[], sort: BookingSort): PanelBooking[] {
    const direction = sort.ascending ? 1 : -1;
    return [...bookings].sort(
        (a, b) => (sortValue(a, sort.column) - sortValue(b, sort.column)) * direction,
    );
}

export function toggleSort(current: BookingSort, column: BookingSortColumn): BookingSort {
    if (current.column === column) return {column, ascending: !current.ascending};
    return {column, ascending: true};
}
